module.exports = __webpack_public_path__ + "img/l3.28cb74ab.webp";